import type { Plugin } from "../core/plugin";
import { PluginRegistry } from "../core/pluginRegistry";

export class ChkTableScrollIndicatorPlugin implements Plugin {
  private readonly scrollEl: HTMLElement | null;
  private readonly track: HTMLElement | null;
  private readonly thumb: HTMLElement | null;
  private readonly onScroll: () => void;
  private readonly resizeObserver: ResizeObserver;

  constructor(private readonly element: HTMLElement) {
    this.scrollEl = element.querySelector<HTMLElement>("[data-table-scroll]");
    this.track = element.querySelector<HTMLElement>(
      "[data-table-scroll-track]",
    );
    this.thumb = element.querySelector<HTMLElement>(
      "[data-table-scroll-thumb]",
    );
    this.onScroll = () => this.update();
    this.resizeObserver = new ResizeObserver(() => this.update());
  }

  init(): void {
    if (!this.scrollEl || !this.track || !this.thumb) return;

    this.scrollEl.addEventListener("scroll", this.onScroll, {
      passive: true,
    });
    // El contenedor pasa de 0px (dentro de un panel `hidden`) a su ancho real
    // al cambiar de método de pago — ResizeObserver recalcula en ambos casos,
    // sin depender de un evento propio del plugin de radios.
    this.resizeObserver.observe(this.scrollEl);
    this.update();
  }

  destroy(): void {
    this.scrollEl?.removeEventListener("scroll", this.onScroll);
    this.resizeObserver.disconnect();
  }

  private update(): void {
    if (!this.scrollEl || !this.track || !this.thumb) return;

    const { scrollWidth, clientWidth, scrollLeft } = this.scrollEl;
    const canScroll = scrollWidth > clientWidth + 1;

    this.track.hidden = !canScroll;
    if (!canScroll) return;

    const thumbRatio = clientWidth / scrollWidth;
    const maxScroll = scrollWidth - clientWidth;
    const scrollRatio = maxScroll > 0 ? scrollLeft / maxScroll : 0;
    const trackWidth = this.track.clientWidth;
    const thumbWidth = trackWidth * thumbRatio;
    const maxThumbOffset = trackWidth - thumbWidth;

    this.thumb.style.width = `${thumbWidth}px`;
    this.thumb.style.transform = `translateX(${maxThumbOffset * scrollRatio}px)`;
  }
}

PluginRegistry.register(
  "chk-table-scroll-indicator",
  ChkTableScrollIndicatorPlugin,
);
